export function isValidUrl(url: string): boolean {
  if (url.indexOf('.') === -1) {
    return false;
  }
  const pattern =
    /^https?:\/\/([\w-]+\.)+[a-zA-Z]{2,}([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?$/;

  if (!url.startsWith('https://') && !url.startsWith('http://')) {
    url = 'https://' + url;
  }

  if (!pattern.test(url)) {
    return false;
  }

  try {
    const validUrl = new URL(url);

    const hostname = validUrl.hostname;

    const parts = hostname.split('.');
    if (parts.length < 2) {
      return false;
    }

    const tld = parts[parts.length - 1];

    return /^[a-zA-Z]{2,}$/.test(tld);
  } catch {
    // URL constructor throws for invalid URLs, which is expected behavior
    // Return false to indicate invalid URL
    return false;
  }
}
